import axiosInstance from "../../../../../axiosInstance";
import {useCallback} from "react";

const usePostProductAITools = () => {
  const baseUrl = window.localStorage.getItem("BaseURL")
  const endpoint = "/services/projectmanagement/api/products"
  const fullUrl = baseUrl + endpoint;

  const generateFormData = (...args) => {
    const formData = new FormData();

    const dataObj = args[0]

    Object.entries(dataObj).forEach(([key, value]) => {
      formData.append(key, value);
    })

    return formData
  }

  return useCallback((params) => {
    const formData = generateFormData(params)
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(fullUrl, formData)
        .then((res) => resolve(res.data))
        .catch(reject)
    })
  }, [fullUrl])
};

export default usePostProductAITools;
